import RestClient from './restClient';

export default class BaseRepository {
  client;

  constructor(servicePath, version = 'v1') {
    this.client = new RestClient(`/${version}/${servicePath}`);
  }
}

